<template>
    <MainLayout>
        <LoaderPage v-if="loadingPage" />
        <div :class="theme === 'dark' ? 'tw-bg-[#151515]' : 'tw-bg-slate-50'" class="tw-sticky tw-top-0 tw-z-10">
            <div class="tw-mx-auto tw-px-6 tw-py-4 tw-flex tw-flex-col md:tw-flex-row tw-gap-3 md:tw-justify-between md:tw-items-center">
                <div>
                    <h1 :class="theme === 'dark' ? 'tw-text-white' : 'tw-text-slate-800'" class="tw-text-2xl tw-font-bold">Configurações da Unidade</h1>
                </div>
                <div class="tw-flex tw-items-center tw-gap-4 tw-w-full md:tw-w-auto">
                    <div v-if="permissaoEditar" class="tw-flex tw-gap-3 md:tw-justify-end tw-w-full md:tw-w-auto">
                        <button 
                            @click="resetParametros" 
                            :class="theme === 'dark' ? 'tw-bg-slate-800 tw-text-slate-300 hover:tw-bg-slate-700' : 'tw-bg-gray-300 tw-text-slate-700 hover:tw-bg-gray-400'" 
                            class="tw-flex-1 md:tw-flex-none tw-px-5 tw-py-2.5 tw-text-sm tw-font-semibold tw-rounded-xl"
                        >
                            Descartar
                        </button>
                        <button 
                            @click="storeParametrosConfiguracoes"
                            :disabled="saveParametrosLoading"
                            :class="theme === 'dark' ? 'tw-bg-blue-500 hover:tw-bg-blue-600 focus:tw-ring-blue-500/20' : 'tw-bg-blue-600 hover:tw-bg-blue-700 focus:tw-ring-blue-100'"
                            class="tw-flex-1 md:tw-flex-none tw-px-6 tw-py-2.5 tw-text-white tw-text-sm tw-font-bold tw-rounded-xl tw-shadow-sm focus:tw-ring-4 disabled:tw-opacity-50"
                        >
                            <span v-if="!saveParametrosLoading">Salvar Configuração</span>
                            <span v-else>Processando...</span>
                        </button>
                    </div>
                    <span v-if="!permissaoEditar" :class="theme === 'dark' ? 'tw-bg-amber-500/10 tw-text-amber-400 tw-border-amber-500/20' : 'tw-bg-amber-50 tw-text-amber-700 tw-border-amber-200'" class="tw-px-4 tw-py-1.5 tw-rounded-full tw-border">
                        Modo Visualização
                    </span>
                </div>
            </div>
        </div>
        <main :class="theme === 'dark' ? 'tw-bg-[#151515]' : 'tw-bg-slate-50'" class="tw-min-h-screen tw-mx-auto tw-p-6">
            <div class="md:tw-flex">
                <section class="tw-w-full tw-rounded-2xl tw-p-4 tw-overflow-hidden">
                    <div :class="theme === 'dark' ? 'tw-bg-[#1a1d21]' : 'tw-bg-white'" class="tw-rounded-2xl tw-shadow-2xl">
                        <div class="tw-flex tw-items-center tw-gap-3 tw-px-5 tw-py-4 tw-border-b" :class="theme === 'dark' ? 'tw-border-white/5' : 'tw-border-slate-100'">
                                <div class="tw-p-2 tw-rounded-lg" :class="theme === 'dark' ? 'tw-bg-green-500/10 tw-text-green-400' : 'tw-bg-green-50 tw-text-green-600'">
                                    <svg class="tw-w-5 tw-h-5" fill="currentColor" viewBox="0 0 24 24">
                                        <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
                                    </svg>
                                </div>
                                <div>
                                    <h3 :class="theme === 'dark' ? 'tw-text-slate-100' : 'tw-text-slate-800'" class="tw-font-semibold">Notificações via WhatsApp</h3>
                                    <p :class="theme === 'dark' ? 'tw-text-slate-500' : 'tw-text-slate-500'" class="xs:tw-text-xs md:tw-text-sm tw-mt-0.5">Escolha quais eventos deseja receber alertas por WhatsApp</p>
                                </div>
                        </div>
                        <div class="tw-px-5 tw-py-4 tw-flex tw-flex-col tw-gap-1">
                            <div 
                                v-for="notif in notificacoes_opcoes"
                                :key="notif.key"
                                class="tw-flex tw-items-center tw-justify-between tw-py-2.5 tw-px-3 tw-rounded-xl"
                                :class="[
                                    notif.key === 'notify_aeracao_sem_comunicacao' || 
                                    notif.key === 'notify_termometria_sem_comunicacao' ||
                                    notif.key === 'notify_media_temperatura' || 
                                    notif.key === 'notify_nivel_silo' ? 'tw-opacity-50' : '',
                                ]"
                            >
                                <div class="tw-flex tw-flex-col tw-gap-0.5">
                                    <span :class="theme === 'dark' ? 'tw-text-slate-300' : 'tw-text-slate-700'" class="tw-text-sm tw-font-medium">{{ notif.label }}</span>
                                    <small :class="theme === 'dark' ? 'tw-text-slate-400' : 'tw-text-slate-600'" class="xs:tw-hidden sm:tw-block tw-text-xs tw-font-small">{{ notif.desc }}</small>
                                </div>
                                <div class="tw-flex tw-items-center tw-gap-3">
                                    <template v-if="notif.key === 'notify_alerta_temperatura' && notificacoes_whatsapp[notif.key] == 1">
                                        <div class="tw-flex tw-items-center tw-gap-1.5">
                                            <span :class="theme === 'dark' ? 'tw-text-slate-500' : 'tw-text-slate-400'" class="tw-text-xs">Temperatura limite</span>
                                            <input 
                                                type="integer" 
                                                v-model="notificacoes_whatsapp.valor_temp_alerta"
                                                :disabled="!permissaoEditar"
                                                :class="theme === 'dark' ? 'tw-bg-slate-700 tw-text-slate-200 disabled:tw-opacity-50' : 'tw-bg-slate-100 tw-text-slate-700 disabled:tw-opacity-90'"
                                                class="tw-text-center tw-w-[6ch] tw-text-xs tw-px-2 tw-py-1 tw-rounded-lg tw-outline-none"
                                            >
                                        </div>
                                    </template>
                                    <template v-if="notif.key === 'notify_horas_aeradas' && notificacoes_whatsapp[notif.key] == 1">
                                        <div class="tw-flex tw-items-center tw-gap-1.5">
                                            <span :class="theme === 'dark' ? 'tw-text-slate-500' : 'tw-text-slate-400'" class="tw-text-xs">Envio diário às</span>
                                            <input 
                                                type="time" 
                                                v-model="notificacoes_whatsapp.horario_envio_horas_aeradas"
                                                :disabled="!permissaoEditar"
                                                :class="theme === 'dark' ? 'tw-bg-slate-700 tw-text-slate-200 disabled:tw-opacity-50' : 'tw-bg-slate-100 tw-text-slate-700 disabled:tw-opacity-90'"
                                                class="tw-text-xs tw-px-2 tw-py-1 tw-rounded-lg tw-outline-none"
                                            >
                                        </div>
                                    </template>
                                    <template v-if="notif.key === 'notify_media_temperatura' || notif.key === 'notify_nivel_silo' || notif.key === 'notify_termometria_sem_comunicacao' || notif.key === 'notify_aeracao_sem_comunicacao'">
                                        <div class="tw-flex tw-items-center tw-gap-1.5">
                                            <span class="tw-text-xs tw-text-red-500 tw-font-medium tw-border tw-border-red-500 tw-px-2 tw-py-1 tw-rounded">Em Desenvolvimento</span>
                                        </div>
                                    </template>
                                    <label class="tw-relative tw-inline-flex tw-items-center tw-cursor-pointer" :class="{ 'tw-pointer-events-none': !permissaoEditar }">
                                        <input 
                                            type="checkbox" 
                                            v-model="notificacoes_whatsapp[notif.key]"
                                            true-value="1"
                                            false-value="0"
                                            :disabled="(!permissaoEditar || notif.key === 'notify_media_temperatura' || notif.key === 'notify_nivel_silo' || notif.key === 'notify_termometria_sem_comunicacao' || notif.key === 'notify_aeracao_sem_comunicacao')"
                                            class="tw-sr-only tw-peer"
                                        >
                                        <div 
                                            :class="theme === 'dark' 
                                                ? 'tw-w-9 tw-h-5 tw-bg-slate-700 tw-rounded-full tw-peer peer-checked:tw-bg-green-500 peer-disabled:tw-opacity-50' 
                                                : 'tw-w-9 tw-h-5 tw-bg-gray-200 tw-rounded-full tw-peer peer-checked:tw-bg-green-500 peer-disabled:tw-opacity-90'"
                                            class="after:tw-content-[''] after:tw-absolute after:tw-top-[2px] after:tw-left-[2px] after:tw-bg-white after:tw-rounded-full after:tw-h-4 after:tw-w-4 after:tw-transition-transform peer-checked:after:tw-translate-x-4"
                                        ></div>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div class="tw-px-5 tw-py-4">
                            <div class="tw-flex tw-items-center tw-justify-between tw-mb-3">
                                <h3 :class="theme === 'dark' ? 'tw-text-slate-300' : 'tw-text-slate-700'" class="tw-text-sm tw-font-semibold">Números cadastrados</h3>
                            </div>
                            <div class="tw-flex tw-flex-col tw-gap-2 tw-mb-4">
                                <div 
                                    v-for="(numero, index) in numeros_whatsapp" 
                                    :key="numero.id || index"
                                    class="tw-flex tw-items-center tw-gap-3 tw-p-3 tw-rounded-xl"
                                    :class="theme === 'dark' ? 'tw-bg-[#151515]' : 'tw-bg-slate-50'"
                                >
                                    <div class="tw-flex-1 tw-min-w-0">
                                        <template v-if="editingNumero === index">
                                            <div class="tw-flex tw-gap-2">
                                                <input 
                                                    v-model="numero.descricao"
                                                    placeholder="Nome"
                                                    :class="theme === 'dark' ? 'tw-bg-slate-700 tw-text-slate-200 tw-placeholder-slate-500' : 'tw-bg-gray-200 tw-text-slate-700 tw-border-slate-300 focus:tw-border-green-500'"
                                                    class="tw-text-xs tw-px-2 tw-py-1.5 tw-rounded-lg tw-outline-none tw-w-1/2"
                                                >
                                                <input 
                                                    v-model="numero.numero"
                                                    placeholder="55DDD99999999"
                                                    :class="theme === 'dark' ? 'tw-bg-slate-700 tw-text-slate-200 tw-placeholder-slate-500' : 'tw-bg-gray-200 tw-text-slate-700 tw-border-slate-300 focus:tw-border-green-500'"
                                                    class="tw-text-xs tw-px-2 tw-py-1.5 tw-rounded-lg tw-outline-none tw-w-1/2"
                                                >
                                            </div>
                                        </template>
                                        <template v-else>
                                            <p :class="theme === 'dark' ? 'tw-text-slate-200' : 'tw-text-slate-700'" class="tw-text-sm tw-font-medium tw-truncate">{{ numero.descricao }}</p>
                                            <p :class="theme === 'dark' ? 'tw-text-slate-500' : 'tw-text-slate-400'" class="tw-text-xs tw-mt-0.5">{{ numero.numero }}</p>
                                        </template>
                                    </div>
                                    <div v-if="permissaoEditar" class="tw-flex tw-items-center tw-gap-1 tw-flex-shrink-0">
                                        <template v-if="editingNumero === index">
                                            <button @click="confirmEditNumero(index)" class="tw-p-1.5 tw-rounded-lg tw-text-green-500 hover:tw-bg-green-500/10">
                                                <svg class="tw-w-5 tw-h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"/></svg>
                                            </button>
                                            <button @click="cancelEditNumero" class="tw-p-1.5 tw-rounded-lg" :class="theme === 'dark' ? 'tw-text-slate-500 hover:tw-bg-white/5' : 'tw-text-slate-400 hover:tw-bg-slate-100'">
                                                <svg class="tw-w-5 tw-h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/></svg>
                                            </button>
                                        </template>
                                        <template v-else>
                                            <button @click="startEditNumero(index)" class="tw-p-1.5 tw-rounded-lg" :class="theme === 'dark' ? 'tw-text-slate-500 hover:tw-bg-white/5 hover:tw-text-slate-300' : 'tw-text-slate-400 hover:tw-bg-slate-100 hover:tw-text-slate-600'">
                                                <svg class="tw-w-5 tw-h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"/></svg>
                                            </button>
                                            <button @click="removeNumero(index)" class="tw-p-1.5 tw-rounded-lg" :class="theme === 'dark' ? 'tw-text-slate-500 hover:tw-bg-red-500/10 hover:tw-text-red-400' : 'tw-text-slate-400 hover:tw-bg-red-50 hover:tw-text-red-500'">
                                                <svg class="tw-w-5 tw-h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"/></svg>
                                            </button>
                                        </template>
                                    </div>
                                </div>
                                <div v-if="numeros_whatsapp.length === 0" class="tw-py-6 tw-text-center">
                                    <p :class="theme === 'dark' ? 'tw-text-slate-600' : 'tw-text-slate-400'" class="tw-text-sm">Nenhum número cadastrado</p>
                                </div>
                            </div>
                            <div v-if="permissaoEditar">
                                <div v-if="!showAddNumeroForm" class="tw-flex tw-justify-start">
                                    <button 
                                        @click="showAddNumeroForm = true"
                                        :class="theme === 'dark' ? 'tw-text-green-400 hover:tw-bg-green-500/10 tw-border-green-500/20' : 'tw-text-green-600 hover:tw-bg-green-50 tw-border-green-200'"
                                        class="tw-flex tw-items-center tw-gap-1.5 tw-text-sm tw-font-medium tw-px-3 tw-py-2 tw-rounded-xl tw-border"
                                    >
                                        <svg class="tw-w-4 tw-h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4"/></svg>
                                        Adicionar número
                                    </button>
                                </div>

                                <div v-else class="tw-p-3 tw-rounded-xl tw-flex tw-flex-col tw-gap-2" :class="theme === 'dark' ? 'tw-bg-[#151515]' : 'tw-bg-slate-50'">
                                    <p :class="theme === 'dark' ? 'tw-text-slate-400' : 'tw-text-slate-500'" class="tw-text-xs tw-font-medium tw-mb-1">Novo número</p>
                                    <div class="tw-flex tw-gap-2">
                                        <input 
                                            v-model="novoNumero.descricao"
                                            placeholder="Nome ou descrição"
                                            :class="theme === 'dark' ? 'tw-bg-slate-700 tw-text-slate-200 tw-placeholder-slate-500' : 'tw-bg-gray-200 tw-text-slate-700'"
                                            class="tw-text-sm tw-px-3 tw-py-2 tw-rounded-xl tw-outline-none tw-flex-1"
                                        >
                                        <input 
                                            v-model="novoNumero.numero"
                                            placeholder="55DDD99999999"
                                            :class="theme === 'dark' ? 'tw-bg-slate-700 tw-text-slate-200 tw-placeholder-slate-500' : 'tw-bg-gray-200 tw-text-slate-700'"
                                            class="tw-text-sm tw-px-3 tw-py-2 tw-rounded-xl tw-outline-none tw-flex-1"
                                        >
                                    </div>
                                    <div class="tw-flex tw-gap-2 tw-justify-end tw-mt-1">
                                        <button 
                                            @click="cancelAddNumero"
                                            :class="theme === 'dark' ? 'tw-bg-slate-700 tw-text-slate-300 hover:tw-bg-slate-600' : 'tw-bg-gray-200 tw-text-slate-600 hover:tw-bg-gray-300'"
                                            class="tw-px-4 tw-py-1.5 tw-text-sm tw-rounded-xl"
                                        >Cancelar</button>
                                        <button 
                                            @click="addNumero"
                                            :class="theme === 'dark' ? 'tw-bg-green-500 hover:tw-bg-green-600' : 'tw-bg-green-600 hover:tw-bg-green-700'"
                                            class="tw-px-4 tw-py-1.5 tw-text-white tw-text-sm tw-font-semibold tw-rounded-xl"
                                        >Adicionar</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                 <section class="tw-w-full tw-rounded-2xl tw-p-4">
                    <div :class="theme === 'dark' ? 'tw-bg-[#1a1d21] tw-rounded-xl tw-mb-2 tw-shadow-2xl' : 'tw-bg-white tw-rounded-xl tw-mb-2 tw-shadow-2xl'">
                        <div class="tw-border-b tw-flex tw-items-center tw-justify-between tw-px-5 tw-py-4" :class="theme === 'dark' ? 'tw-border-white/5' : 'tw-border-slate-100'">
                            <div class="tw-flex tw-items-center tw-gap-4">
                                <div class="tw-p-2 tw-rounded-xl" :class="theme === 'dark' ? 'tw-bg-blue-500/10 tw-text-blue-400' : 'tw-bg-blue-50 tw-text-blue-600'">
                                    <svg class="tw-w-5 tw-h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"/></svg>
                                </div>
                                <div>
                                    <h3 :class="theme === 'dark' ? 'tw-text-slate-200' : 'tw-text-slate-700'" class="tw-font-semibold">Enviar Relatório de Termometria via E-mail e Whatsapp</h3>
                                    <p :class="theme === 'dark' ? 'tw-text-slate-500' : 'tw-text-slate-500'" class="xs:tw-text-xs md:tw-text-sm tw-mt-0.5">Ativar o envio automático do relatório de termometria</p>
                                </div>
                            </div>
                            <label class="tw-relative tw-inline-flex tw-items-center tw-cursor-pointer">
                                <input 
                                    type="checkbox" 
                                    v-model="parametros_configuracoes['envio_email_termometria']" 
                                    true-value="1" 
                                    false-value="0" 
                                    :disabled="!permissaoEditar" 
                                    class="tw-sr-only tw-peer"
                                >
                                <div :class="theme === 'dark' ? 'tw-w-12 tw-h-6 tw-bg-slate-700 tw-rounded-full tw-peer peer-checked:tw-bg-blue-500 peer-disabled:tw-opacity-50 ' : 'tw-w-12 tw-h-6 tw-bg-gray-300 tw-rounded-full tw-peer peer-checked:tw-bg-blue-600 peer-disabled:tw-opacity-90'" class="after:tw-content-[''] after:tw-absolute after:tw-top-[2px] after:tw-left-[2px] after:tw-bg-white after:tw-rounded-full after:tw-h-5 after:tw-w-5 after:tw-transition-transform peer-checked:after:tw-translate-x-6"></div>
                            </label>
                        </div>
                        <div class="tw-px-5 tw-py-4">
                                <div class="tw-flex tw-items-center tw-justify-between tw-mb-3">
                                    <h3 :class="theme === 'dark' ? 'tw-text-slate-300' : 'tw-text-slate-700'" class="tw-text-sm tw-font-semibold">Emails cadastrados</h3>
                                </div>
                                <div class="tw-flex tw-flex-col tw-gap-2 tw-mb-4">
                                    <div 
                                        v-for="(email, index) in emails" 
                                        :key="email.id || index"
                                        class="tw-flex tw-items-center tw-gap-3 tw-p-3 tw-rounded-xl"
                                        :class="theme === 'dark' ? 'tw-bg-[#151515]' : 'tw-bg-slate-50'"
                                    >
                                        <div class="tw-flex-1 tw-min-w-0">
                                            <template v-if="editingEmail === index">
                                                <div class="tw-flex tw-gap-2">
                                                    <input 
                                                        v-model="email.email"
                                                        placeholder="Email"
                                                        :class="theme === 'dark' ? 'tw-bg-slate-700 tw-text-slate-200 tw-placeholder-slate-500' : 'tw-bg-gray-200 tw-text-slate-700'"
                                                        class="tw-text-xs tw-px-2 tw-py-1.5 tw-rounded-lg tw-outline-none tw-w-1/2"
                                                    >
                                                </div>
                                            </template>
                                            <template v-else>
                                                <p :class="theme === 'dark' ? 'tw-text-slate-200' : 'tw-text-slate-700'" class="tw-text-sm tw-font-medium tw-truncate">{{ email.email }}</p>
                                            </template>
                                        </div>
                                        <div v-if="permissaoEditar" class="tw-flex tw-items-center tw-gap-1 tw-flex-shrink-0">
                                            <template v-if="editingEmail === index">
                                                <button @click="confirmEditEmail(index)" class="tw-p-1.5 tw-rounded-lg tw-text-green-500 hover:tw-bg-green-500/10">
                                                    <svg class="tw-w-5 tw-h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"/></svg>
                                                </button>
                                                <button @click="cancelEditEmail" class="tw-p-1.5 tw-rounded-lg" :class="theme === 'dark' ? 'tw-text-slate-500 hover:tw-bg-white/5' : 'tw-text-slate-400 hover:tw-bg-slate-100'">
                                                    <svg class="tw-w-5 tw-h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/></svg>
                                                </button>
                                            </template>
                                            <template v-else>
                                                <button @click="startEditEmail(index)" class="tw-p-1.5 tw-rounded-lg" :class="theme === 'dark' ? 'tw-text-slate-500 hover:tw-bg-white/5 hover:tw-text-slate-300' : 'tw-text-slate-400 hover:tw-bg-slate-100 hover:tw-text-slate-600'">
                                                    <svg class="tw-w-5 tw-h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"/></svg>
                                                </button>
                                                <button @click="removeEmail(index)" class="tw-p-1.5 tw-rounded-lg" :class="theme === 'dark' ? 'tw-text-slate-500 hover:tw-bg-red-500/10 hover:tw-text-red-400' : 'tw-text-slate-400 hover:tw-bg-red-50 hover:tw-text-red-500'">
                                                    <svg class="tw-w-5 tw-h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"/></svg>
                                                </button>
                                            </template>
                                        </div>
                                    </div>
                                    <div v-if="emails.length === 0" class="tw-py-6 tw-text-center">
                                        <p :class="theme === 'dark' ? 'tw-text-slate-600' : 'tw-text-slate-400'" class="tw-text-sm">Nenhum email cadastrado</p>
                                    </div>
                                </div>
                                <div v-if="permissaoEditar">
                                    <div v-if="!showAddEmailForm" class="tw-flex tw-justify-start">
                                        <button 
                                            @click="showAddEmailForm = true"
                                            :class="theme === 'dark' ? 'tw-text-green-400 hover:tw-bg-green-500/10 tw-border-green-500/20' : 'tw-text-green-600 hover:tw-bg-green-50 tw-border-green-200'"
                                            class="tw-flex tw-items-center tw-gap-1.5 tw-text-sm tw-font-medium tw-px-3 tw-py-2 tw-rounded-xl tw-border"
                                        >
                                            <svg class="tw-w-4 tw-h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4"/></svg>
                                            Adicionar email
                                        </button>
                                    </div>

                                    <div v-else class="tw-p-3 tw-rounded-xl tw-flex tw-flex-col tw-gap-2" :class="theme === 'dark' ? 'tw-bg-[#151515]' : 'tw-bg-slate-50'">
                                        <p :class="theme === 'dark' ? 'tw-text-slate-400' : 'tw-text-slate-500'" class="tw-text-xs tw-font-medium tw-mb-1">Novo email</p>
                                        <div class="tw-flex tw-gap-2">
                                            <input 
                                                v-model="novoEmail.email"
                                                placeholder="Endereço de email"
                                                :class="theme === 'dark' ? 'tw-bg-slate-700 tw-text-slate-200 tw-placeholder-slate-500' : 'tw-bg-gray-200 tw-text-slate-700'"
                                                class="tw-text-sm tw-px-3 tw-py-2 tw-rounded-xl tw-outline-none tw-flex-1"
                                            >
                                        </div>
                                        <div class="tw-flex tw-gap-2 tw-justify-end tw-mt-1">
                                            <button 
                                                @click="cancelAddEmail"
                                                :class="theme === 'dark' ? 'tw-bg-slate-700 tw-text-slate-300 hover:tw-bg-slate-600' : 'tw-bg-gray-200 tw-text-slate-600 hover:tw-bg-gray-300'"
                                                class="tw-px-4 tw-py-1.5 tw-text-sm tw-rounded-xl"
                                            >Cancelar</button>
                                            <button 
                                                @click="addEmail"
                                                :class="theme === 'dark' ? 'tw-bg-green-500 hover:tw-bg-green-600' : 'tw-bg-green-600 hover:tw-bg-green-700'"
                                                class="tw-px-4 tw-py-1.5 tw-text-white tw-text-sm tw-font-semibold tw-rounded-xl"
                                            >Adicionar</button>
                                        </div>
                                    </div>
                                </div>
                        </div>
                        <div class="tw-px-5 tw-py-4">
                            <div class="tw-flex tw-items-center tw-justify-between tw-mb-3">
                                <h3 :class="theme === 'dark' ? 'tw-text-slate-300' : 'tw-text-slate-700'" class="tw-text-sm tw-font-semibold">Enviar relatório via whatsapp</h3>
                            </div>
                            <div class="tw-flex tw-flex-col tw-gap-2 tw-mb-4">
                                <div 
                                    v-for="(numero, index) in numeros_whatsapp" 
                                    :key="numero.id || index"
                                    class="tw-flex tw-items-center tw-gap-3 tw-p-3 tw-rounded-xl"
                                    :class="theme === 'dark' ? 'tw-bg-[#151515]' : 'tw-bg-slate-50'"
                                >
                                    <div class="tw-flex-1 tw-min-w-0">
                                        <div>
                                            <p :class="theme === 'dark' ? 'tw-text-slate-200' : 'tw-text-slate-700'" class="tw-text-sm tw-font-medium tw-truncate">{{ numero.descricao }}</p>
                                            <p :class="theme === 'dark' ? 'tw-text-slate-500' : 'tw-text-slate-400'" class="tw-text-xs tw-mt-0.5">{{ numero.numero }}</p>
                                        </div>
                                    </div>
                                    <div class="tw-flex tw-items-center tw-gap-1 tw-flex-shrink-0">
                                        <label class="tw-relative tw-inline-flex tw-items-center tw-cursor-pointer" :class="{ 'tw-pointer-events-none': !permissaoEditar }">
                                        <input 
                                            type="checkbox" 
                                            v-model="numero.envio_relatorio_whatsapp"
                                            true-value="1"
                                            false-value="0"
                                            :disabled="!permissaoEditar"
                                            class="tw-sr-only tw-peer"
                                        >
                                        <div 
                                            :class="theme === 'dark' 
                                                ? 'tw-w-9 tw-h-5 tw-bg-slate-700 tw-rounded-full tw-peer peer-checked:tw-bg-green-500 peer-disabled:tw-opacity-50 ' 
                                                : 'tw-w-9 tw-h-5 tw-bg-gray-200 tw-rounded-full tw-peer peer-checked:tw-bg-green-500 peer-disabled:tw-opacity-90'"
                                            class="after:tw-content-[''] after:tw-absolute after:tw-top-[2px] after:tw-left-[2px] after:tw-bg-white after:tw-rounded-full after:tw-h-4 after:tw-w-4 after:tw-transition-transform peer-checked:after:tw-translate-x-4"
                                        ></div>
                                    </label>
                                    </div>
                                </div>
                                <div v-if="numeros_whatsapp.length === 0" class="tw-py-6 tw-text-center">
                                    <p :class="theme === 'dark' ? 'tw-text-slate-600' : 'tw-text-slate-400'" class="tw-text-sm">Nenhum número cadastrado</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </main>
    </MainLayout>
</template>

<script>
import MainLayout from '@/components/layouts/v2/MainLayout.vue';
import LoaderPage from '@/components/ui/v2/LoaderPage.vue';
import { useToast } from 'vue-toastification';
import { mapState } from 'vuex';

export default {
    components: {
        MainLayout,
        LoaderPage
    },

    data() {
        return {
            saveParametrosLoading: false,
            parametros_configuracoes: {
                envio_email_termometria: null
            },
            notificacoes_whatsapp: {
                notify_alerta_temperatura: 0,
                notify_horas_aeradas: 0,
                notify_status_motor: 0,
                notify_media_temperatura: 0,
                notify_nivel_silo: 0,
                notify_estacao_sem_comunicacao: 0,
                notify_aeracao_sem_comunicacao: 0,
                notify_termometria_sem_comunicacao: 0,
                horario_envio_horas_aeradas: '09:00:00',
                valor_temp_alerta: 30
            },
            numeros_whatsapp: [],
            emails: [],
            notificacoes_opcoes: [
                { key: 'notify_alerta_temperatura', label: 'Alerta de temperatura', desc: 'Receber notificação diaria de sensores acima do limite (às 17h)' },
                { key: 'notify_horas_aeradas', label: 'Horas aeradas', desc: 'Receber notificação diária do total de horas aeradas nas últimas 24h' },
                { key: 'notify_status_motor', label: 'Status do motor', desc: 'Receber notificações de acionamento e de desligamento dos motores' },
                { key: 'notify_media_temperatura', label: 'Média de temperatura', desc: 'Receber notificação da média de temperatura de cada silo' },
                { key: 'notify_nivel_silo', label: 'Nível do silo', desc: 'Receber notificação do nível de cada silo' },
                { key: 'notify_estacao_sem_comunicacao', label: 'Estação sem comunicação', desc: 'Receber notificação quando a estação não estiver comunicando' },
                { key: 'notify_aeracao_sem_comunicacao', label: 'Aeração sem comunicação', desc: 'Receber notificação quando a aeração não estiver comunicando' },
                { key: 'notify_termometria_sem_comunicacao', label: 'Termometria sem comunicação', desc: 'Receber notificação quando a termometria não estiver comunicando' },
            ],
            loadingPage: true,
            permissaoEditar: false,
            parametrosOriginais: {},
            notificacoesOriginais: {},
            numerosOriginais: [],
            emailsOriginais: [],
            showAddNumeroForm: false,
            showAddEmailForm: false,
            novoNumero: { descricao: '', numero: '', envio_relatorio_whatsapp: false},
            novoEmail: { email: '' },
            editingNumero: null,
            editingEmail: null,
            editingBackup: null,
            editingEmailBackup: null
        }
    },

    computed: {
        ...mapState({
            theme: state => state.ui.theme,
        }),
    },

    async mounted() {
        this.toast = useToast();
        this.getParametrosConfiguracoes();
    },

    methods: {
        async getParametrosConfiguracoes() {
            try {
                const response = await this.$store.dispatch('unidade/getConfiguracoes', this.$route.params.unidade);
                await this.$store.dispatch("unidade/fetchUnidade", response.unidade_id || this.$route.params.unidade);
                
                if (response) {
                    this.parametros_configuracoes = {
                        envio_email_termometria: response.data.envio_email_termometria || 0
                    };
                    this.parametrosOriginais = JSON.parse(JSON.stringify(this.parametros_configuracoes));

                    if (response.data.notificacoes_whatsapp) {
                        const nw = response.data.notificacoes_whatsapp;
                        this.notificacoes_whatsapp = {
                            notify_alerta_temperatura: nw.notify_alerta_temperatura ?? 0,
                            notify_horas_aeradas: nw.notify_horas_aeradas ?? 0,
                            notify_status_motor: nw.notify_status_motor ?? 0,
                            notify_media_temperatura: nw.notify_media_temperatura ?? 0,
                            notify_nivel_silo: nw.notify_nivel_silo ?? 0,
                            notify_estacao_sem_comunicacao: nw.notify_estacao_sem_comunicacao ?? 0,
                            notify_aeracao_sem_comunicacao: nw.notify_aeracao_sem_comunicacao ?? 0,
                            notify_termometria_sem_comunicacao: nw.notify_termometria_sem_comunicacao ?? 0,
                            horario_envio_horas_aeradas: nw.horario_envio_horas_aeradas ?? '09:00:00',
                            valor_temp_alerta: nw.valor_temp_alerta ?? 30
                        };
                        this.notificacoesOriginais = JSON.parse(JSON.stringify(this.notificacoes_whatsapp));
                    }
                    this.numeros_whatsapp = JSON.parse(JSON.stringify(response.data.numeros_whatsapp || []));
                    this.emails = JSON.parse(JSON.stringify(response.data.emails || []));
                    this.emailsOriginais = JSON.parse(JSON.stringify(this.emails));
                    this.numerosOriginais = JSON.parse(JSON.stringify(this.numeros_whatsapp));

                    this.permissaoEditar = this.$store.state.unidade.unidade.permissoes.alteracao_configuracoes_unidade !== 0;
                } 
            } catch (error) {
                console.error("Erro ao buscar os dados:", error);
                this.toast.error("Erro ao buscar as configurações");
                this.permissaoEditar = false;
            }
            this.loadingPage = false;
        },

        async storeParametrosConfiguracoes() {
            try{
                this.saveParametrosLoading = true;
                const unidade = this.$route.params.unidade;  
                const datas = JSON.parse(JSON.stringify(this.parametros_configuracoes));
                datas.notificacoes_whatsapp = JSON.parse(JSON.stringify(this.notificacoes_whatsapp));
                datas.numeros_whatsapp = JSON.parse(JSON.stringify(this.numeros_whatsapp));
                datas.emails = JSON.parse(JSON.stringify(this.emails));
                await this.$store.dispatch('unidade/storeConfiguracoes', {'unidadeId': unidade, 'data': datas });
                
                this.toast.success("Configuração salva com sucesso.");
                this.parametrosOriginais = JSON.parse(JSON.stringify(this.parametros_configuracoes));
            } catch (error) {
                this.getParametrosConfiguracoes();
                console.error("Erro ao atualizar configurações:", error);
                this.toast.error("Erro ao atualizar a configuração");
            } finally {
                this.saveParametrosLoading = false;
            }
        },

        resetParametros() {
            this.parametros_configuracoes = JSON.parse(JSON.stringify(this.parametrosOriginais));
            this.notificacoes_whatsapp = JSON.parse(JSON.stringify(this.notificacoesOriginais));
            this.numeros_whatsapp = JSON.parse(JSON.stringify(this.numerosOriginais));
            this.emails = JSON.parse(JSON.stringify(this.emailsOriginais));
            this.cancelAddNumero();
            this.editingNumero = null;
            this.editingBackup = null;
            this.cancelAddEmail();
            this.editingEmail = null;
            this.editingEmailBackup = null;
        },

        addNumero() {
            if (!this.novoNumero.descricao.trim() || !this.novoNumero.numero.trim()) {
                this.toast.warning("Preencha o nome e o número antes de adicionar.");
                return;
            }
            this.numeros_whatsapp.push({ ...this.novoNumero });
            this.cancelAddNumero();
        },

        addEmail() {
            if (!this.novoEmail.email.trim()) {
                this.toast.warning("Preencha o email antes de adicionar.");
                return;
            }
            this.emails.push({ ...this.novoEmail });
            this.cancelAddEmail();
        },

        cancelAddNumero() {
            this.showAddNumeroForm = false;
            this.novoNumero = { descricao: '', numero: '' };
        },

        cancelAddEmail() {
            this.showAddEmailForm = false;
            this.novoEmail = { email: '' };
        },

        removeNumero(index) {
            this.numeros_whatsapp.splice(index, 1);
            if (this.editingNumero === index) this.editingNumero = null;
        },

        removeEmail(index) {
            this.emails.splice(index, 1);
            if (this.editingEmail === index) this.editingEmail = null;
        },

        startEditNumero(index) {
            this.editingBackup = { ...this.numeros_whatsapp[index] };
            this.editingNumero = index;
        },

        startEditEmail(index) {
            this.editingEmailBackup = { ...this.emails[index] };
            this.editingEmail = index;
        },

        confirmEditNumero(index) {
            if (!this.numeros_whatsapp[index].descricao.trim() || !this.numeros_whatsapp[index].numero.trim()) {
                this.toast.warning("Preencha o nome e o número.");
                return;
            }
            this.editingNumero = null;
            this.editingBackup = null;
        },

        confirmEditEmail(index) {
            if (!this.emails[index].email.trim()) {
                this.toast.warning("Preencha o email.");
                return;
            }
            this.editingEmail = null;
            this.editingEmailBackup = null;
        },

        cancelEditNumero() {
            if (this.editingBackup !== null && this.editingNumero !== null) {
                this.numeros_whatsapp.splice(this.editingNumero, 1, { ...this.editingBackup });
            }
            this.editingNumero = null;
            this.editingBackup = null;
        },

        cancelEditEmail() {
            if (this.editingEmailBackup !== null && this.editingEmail !== null) {
                this.emails.splice(this.editingEmail, 1, { ...this.editingEmailBackup });
            }
            this.editingEmail = null;
            this.editingEmailBackup = null;
        }
    }
}
</script>
